import { type UseMutationResult, useMutation } from '@tanstack/react-query';

import api from '@/axios';
import type { PurchasePlanningWeekParams } from '@/features/purchase-planning/hooks/use-purchase-planning-week-params';
import { CREATE_LOT_SIZING_KEY } from '@/keys';
import { LotSizingType } from '@/types/core/lot-sizing/lot-sizing-type';
import type { PurchasePlanning } from '@/types/core/purchase-planning/purchase-planning';
import type { ExtendedColumnFilter } from '@/types/data-table';

export type CreateLotSizingResponse = {
  id: string;
};

export type CreateLotSizingParams = {
  weekParams: PurchasePlanningWeekParams;
  filters: ExtendedColumnFilter<PurchasePlanning>[];
};

const createLotSizing = async ({
  weekParams,
  filters,
}: CreateLotSizingParams): Promise<CreateLotSizingResponse> => {
  const { year, week, endYear, endWeek } = weekParams;
  const response = await api.post<CreateLotSizingResponse>('/lot-sizings', {
    type: LotSizingType.PO,
    year,
    week,
    endYear,
    endWeek,
    filters,
  });
  return response.data;
};

export const useCreateLotSizing = (): UseMutationResult<
  CreateLotSizingResponse,
  Error,
  CreateLotSizingParams
> =>
  useMutation({
    mutationKey: CREATE_LOT_SIZING_KEY,
    mutationFn: createLotSizing,
  });
